export default "__VITE_ASSET__2e4af783__"